import DatetimePicker from 'vuetify-datetime-picker'
import Vue from 'vue'

Vue.use(DatetimePicker)
